program OrderWebEPL;

uses
  Vcl.Forms,
  WEBLib.Forms, uDirect in 'uDirect.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateFormDirect(TForm1, Form1);
  Application.Run;
end.